var _path, _path2, _path3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAngleUpAlert = function SvgAngleUpAlert(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0617 12.4743L12.0012 10.4138L7.7072 14.7078C7.51956 14.8953 7.26512 15.0006 6.99985 15.0005C6.8685 15.0004 6.73845 14.9745 6.61712 14.9242C6.49578 14.8739 6.38555 14.8002 6.2927 14.7073C6.19986 14.6144 6.12622 14.5041 6.076 14.3827C6.02578 14.2614 5.99995 14.1313 6 13.9999C6.00009 13.7347 6.10556 13.4803 6.2932 13.2928L11.2942 8.29279C11.4817 8.10532 11.736 8 12.0012 8C12.2664 8 12.5207 8.10532 12.7082 8.29279L15.8234 11.4079C15.1735 11.6611 14.5787 12.0241 14.0617 12.4743Z",
    fill: "#3A3A47"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4811 13.8936L16.2942 14.7068C16.3865 14.8023 16.4968 14.8785 16.6188 14.9309C16.7408 14.9833 16.872 15.0109 17.0048 15.012C17.1376 15.0132 17.2693 14.9879 17.3922 14.9376C17.5151 14.8873 17.6267 14.8131 17.7206 14.7192C17.8145 14.6253 17.8887 14.5136 17.939 14.3907C17.9893 14.2678 18.0146 14.1362 18.0135 14.0034C18.0123 13.8706 17.9847 13.7394 17.9323 13.6174C17.8799 13.4954 17.8037 13.385 17.7082 13.2928L17.4533 13.0379C16.7119 13.1393 16.0351 13.4439 15.4811 13.8936Z",
    fill: "#3A3A47"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 17.0008C22 14.7917 20.2091 13.0008 18 13.0008C15.7909 13.0008 14 14.7917 14 17.0008C14 19.21 15.7909 21.0008 18 21.0008C20.2091 21.0008 22 19.21 22 17.0008Z",
    fill: "#D01E29"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAngleUpAlert, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/angle_up_alert.f8ee704b.svg";
export { ForwardRef as ReactComponent };